// because this mixin is only use between two components, we can locally keep it in ProductList
// folder and access it from the ProductListCarousel

import { serializeDigitalFilters } from '@/SharedFe/utils/localization/digitalFilters';
import { fetchProducts } from '../api/productList';
import { to } from '@/SharedFe/utils';
import {
  getBoxType,
  getDiscountAmount,
  getDiscountRange,
  getPriceRange,
  getProductPrice,
  getProductValue,
  hasDiscountedPrice,
} from '@/SharedFe/utils/tracking/GTMTrackingUtils';

/**
 * @description Vue mixin for carousel. Use in _carouselTemplate
 * @private
 */
export default {
  data() {
    return {
      loading: false,
      displayedProducts: [],
      error: null,
      numberOfProductsPerRow: 4,
      searchParams: '',
    };
  },
  computed: {
    getNumberProductsToShow() {
      return this.numberProductsToShow();
    },
    filters() {
      return serializeDigitalFilters(this.parseDigitalFilters());
    },
  },
  methods: {
    async fetchData() {
      this.error = null;
      this.loading = true;

      if (!this.pimIds && !this.filters) {
        return false;
      }

      this.searchParams = `page.number=1&page.size=${this.getNumberProductsToShow}&sort=position&context.sort.position.enable_smart_sort=1&response.without=facets`;
      // eslint-disable-next-line no-extra-boolean-cast
      this.searchParams = !!this.pimIds ? `${this.pimIds.replace(/\s/g, '')}` : `${this.searchParams}${this.filters}`;

      const [err, data] = await to(fetchProducts(this.searchParams, !!this.pimIds));

      if (err) {
        this.errorMessage = err;
        console.error('ProductList -', err);
        setTimeout(() => {
          this.loading = false;
        }, 500);
        return {};
      }

      if (data.error) {
        this.loading = false;
      }

      if (data && data.items && data.items.length < 1) {
        // error message in case of zero items to show
        const error = 'No items founded for box search query';
        console.error(error);
        this.loading = false;
      }

      if (data.items && data.items.length >= 1) {
        this.loading = false;
        // eslint-disable-next-line no-extra-boolean-cast
        this.displayedProducts = !!this.pimIds ? this.sortItems(data.items, this.pimIds) : data.items;
      }
    },

    sortItems(items, orders) {
      if (orders.indexOf(',') == -1) {
        return items;
      }

      const ordersArr = orders.split(',');
      return items.sort((a, b) => ordersArr.findIndex(boxId => boxId == a.item.id) - ordersArr.findIndex(boxId => boxId == b.item.id));
    },

    parseDigitalFilters() {
      try {
        const stringFilters = JSON.stringify(this.digitalFilters);
        const filterObject = JSON.parse(stringFilters);
        if (Object.keys(filterObject).length === 0) {
          console.error('Empty JSON not allowed in digital filter prop');
          return false;
        }
        return filterObject;
      } catch (err) {
        console.error('invalid JSON - ', err);
        return false;
      }
    },

    numberProductsToShow() {
      const defaultNumberOfProductsToShow = parseInt(this.numberOfProductsToShow);
      if (isNaN(parseInt(this.numberOfProductsToShow))) {
        console.warn(
          'numberOfProductsToShow must be an integer or convert to one, rendered component with default value for numberOfProductsToShow prop',
        );
        return defaultNumberOfProductsToShow;
      }
      if (this.numberOfProductsToShow > this.maxProductsToShow) {
        return this.maxProductsToShow;
      }
      return this.numberOfProductsToShow < defaultNumberOfProductsToShow
        ? defaultNumberOfProductsToShow
        : this.numberProductsIsMultipleOfFour
        ? Math.floor(this.numberOfProductsToShow / this.numberOfProductsPerRow) * this.numberOfProductsPerRow
        : this.numberOfProductsToShow;
    },

    vignetteHandleClick(product, index, list) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list }, // Optional list property.
            products: [
              {
                id: product.item.id,
                name: product.item.name,
                price: getProductPrice(product),
                price_range: getPriceRange(product),
                discounted: hasDiscountedPrice(product),
                product_value: getProductValue(product),
                discount_amount: getDiscountAmount(product),
                discount_amount_range: getDiscountRange(product),
                brand: product.item.brand,
                category: product.item.webUniverse.name,
                box_type: getBoxType(product),
                review_rating: product.item.rating,
                position: index + 1,
                list,
              },
            ],
          },
        },
      });
    },
    goToLink(url) {
      window.location.href = url;
    },
  },
};
